<script lang="ts">
  import { Button } from '@shared/ui/buttons/button';
  import { Icon, type IconNames } from '@shared/ui/icon';

  import { getDataByType, type NoDataType } from '../config';

  export let type: NoDataType;
  export let total: number;
  export let search: string;
  export let filters: string;
  export let buttonName: string | null = null;
  export let buttonIconName: IconNames | undefined = undefined;

  $: noData = getDataByType(type, total, search, filters);
</script>

<div class="flex flex-1 flex-col items-center justify-center gap-8 p-5 text-center">
  <div class="bg-default-100 dark:bg-dark-250 text-default-400 flex h-24 w-24 items-center justify-center rounded-full">
    <span>
      <Icon name="{noData.icon}" />
    </span>
  </div>

  {#if !$$slots.default}
    <div class="text-default-800 dark:text-dark-800 text-base">
      <!-- eslint-disable-next-line -->
      <p class="message max-w-xl">{@html noData.message}</p>
      {#if buttonName}
        <div class="mx-auto mt-5 w-fit">
          <Button variant="secondary" iconPosition="left" iconName="{buttonIconName}" hugged on:click
            >{buttonName}</Button
          >
        </div>
      {/if}
    </div>
  {:else}
    <slot />
  {/if}
</div>
